export default "__VITE_ASSET__f23b6e05__"